import { EffectCallback, DependencyList, useEffect, useLayoutEffect } from 'react'

export function useIsomorphicLayoutEffect(effect: EffectCallback, deps: DependencyList) {
  if (typeof window === 'undefined') {
    return useEffect(effect, deps)
  }
  return useLayoutEffect(effect, deps)
}
